import React from "react";
// ANT DESIGN COMPONENTS
import { Button } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import {
  updateOpenFormDataBlock,
  updateDataBlockRefreshTable,
  updateOpenFormDataBlockAction,
  updateShowDataBlockTable,
} from "../../../redux/tools/toolsSlice";
// AUTHORIZATION
import { Permission, hasPermission } from "../../../utils/validatePermissions";
// INTERFACES
import { RootState } from "../../../app/store";

function DataBlocksHeader() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();
  const [t] = useTranslation("global");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { permissionSet } = useSelector((state: RootState) => state.user);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const handleOpenForm = () => {
    dispatch(updateOpenFormDataBlock(true));
    dispatch(updateOpenFormDataBlockAction("create"));
  };

  const handleReloadPage = () => {
    dispatch(updateDataBlockRefreshTable(true));
    setTimeout(() => {
      dispatch(updateDataBlockRefreshTable(false));
    }, 1000);
  };

  return (
    <div className="generalStyles__pageHeader">
      <div className="generalStyles__mlFix mt-1">
        <Button
          onClick={() => {
            dispatch(updateShowDataBlockTable(false));
          }}
        >
          {t("configuration.cancel")}
        </Button>
      </div>
      {hasPermission(Permission.DataBlocksCatalog, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <Button
            type="primary"
            icon={<FontAwesomeIcon icon={faPlus} className="generalStyles__mrFix" />}
            onClick={handleOpenForm}
          >
            {t("configuration.dataBlock.createNewDataBlock")}
          </Button>
        </div>
      )}
      {hasPermission(Permission.DataBlocksCatalog, permissionSet ?? []) && (
        <div className="generalStyles__mlFix mt-1">
          <Button
            type="primary"
            icon={<FontAwesomeIcon icon={faArrowsRotate} className="generalStyles__mrFix" />}
            onClick={() => {
              handleReloadPage();
            }}
          >
            {t("edgeManagement.banks.refreshTable")}
          </Button>
        </div>
      )}
    </div>
  );
}

export default DataBlocksHeader;
